import React from 'react'

const SingleFood = ({ currentDay, foodSub, title, food, showModal, cat, doctorComment }) => {

    // Si hay comida, definimos el src usando imagen o fallback
    const imgSrc = food && food.image
        ? `/uploads/${food.image}`
        : '/img/default-food.png'; // pon aquí la ruta real de tu imagen default

    return (
        <div className='col-12 col-md-6 col-lg-3 single-food'>
            {!food && (
                <p>No está definido la comida</p>
            )}

            {food && (
                <>
                    <figure>
                        <img
                            src={imgSrc}
                            className='img-fluid'
                            alt={food.title || title}
                        />
                    </figure>

                    <strong>{title}</strong>
                    <h2>{food.title}</h2>
                    <h3>{foodSub}</h3>

                    {doctorComment && (
                        <p>
                            <span>Anotaciones del Doctor: </span>
                            {doctorComment}
                        </p>
                    )}
                </>
            )}

            <a href='#' onClick={(e) => showModal(e, cat)}>Cambiar</a>
        </div>
    )
}

export default SingleFood;
